
import Vue from 'vue'
import { DateTime } from "luxon";

export default Vue.extend({
  name: "DateInput",
  props: {
    value: {
      required: true,
      type: [Date,  DateTime],
    }
  },
  computed: {
    dateString: {
      get(): string {
        const datetime = this.value instanceof Date ? DateTime.fromJSDate(this.value) : this.value;
        return datetime.toISODate()!;
      },
      set(value: string) {
        const datetime = DateTime.fromISO(value);
        this.$emit('input', this.value instanceof Date ? datetime.toJSDate() : datetime);
      },
    }
  }
})
